<template>
  <div>
    <v-card
      outlined
      style="max-height: 30vh;overflow-y: scroll;"
    >
      <template v-for="other in tenant.invoice_others_attributes">
        <v-card-text v-if="!other._destroy" :key="other.key">
          <v-row dense v-if="other.enabled">
            <v-col cols="12" md="3">
              <validation-provider
                v-slot="{ errors }"
                :vid="`others_price-${other.key}`"
                :class="{ requiredMark: other.others_invoice_date !== null }"
                :rules="{ required: other.others_invoice_date !== null, max: 10, numeric: true, max_value: 2147483647}"
                name="その他金額"
              >
                <v-text-field
                  v-model="other.others_price"
                  :error-messages="errors"
                  clearable
                  label="その他金額"
                  hide-details="auto"
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>その他金額</span>
                    <span class="ml-1">
                      ({{ other.others_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="other.others_invoice_date"
                type="month"
                :minimum-date="systemMonth"
                :day-format="date => new Date(date).getDate()"
                @dateChangedCallback="othersInvoiceDateChangedCallback($event, other)"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`others_invoice_date-${other.key}`"
                    :class="{ requiredMark: other.others_price !== null }"
                    :rules="{ required: other.others_price !== null }"
                    name="その他請求適用日"
                  >
                    <v-text-field
                      v-model="other.others_invoice_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="その他請求適用日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`others_title-${other.key}`"
                :rules="{max:20}"
                name="その他タイトル"
              >
                <v-text-field
                  v-model="other.others_title"
                  :error-messages="errors"
                  clearable
                  label="その他タイトル"
                  hide-details="auto"
                  persistent-placeholder
                > 
                  <template v-slot:label>
                    <span>その他タイトル</span>
                    <span class="ml-1">
                      ({{ other.others_title?.length || 0 }} / 20)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <v-btn
                class="error"
                small
                @click="removeButtonClickEvent(other)"
              >
                削除
              </v-btn>
            </v-col>
          </v-row>
          
          <v-row v-else>
            <v-col cols="12" md="3">
              <div class="overline">
                その他金額
              </div>
              <h3 class="font-weight-medium black--text">
                {{ other.others_price }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="3">
              <div class="overline">
                その他請求適用日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ other.others_invoice_date }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="4">
              <div class="overline">
                その他タイトル
              </div>
              <h3 class="font-weight-medium black--text">
                {{ other.others_title }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <v-divider class="mt-2" />
        </v-card-text>
      </template>
    </v-card>
        
    <br />
    <v-row dense>
      <v-col cols="12" class="text-right">
        <v-btn
          class="primary"
          small
          @click="addButtonClickEvent"
        >
          追加
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'InvoiceOtherForm',
  components: {},
  mixins: [],
  props: {
    tenant: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
  },
  data() {
    return {
      systemMonth: moment().format("YYYY-MM"),
      othersInvoiceDatePicker: {}
    }
  },
  watch: {},
  created() {
    // 請求その他項目が０件の場合、空行を追加（追加ボタンクリック時と同じ処理）する
    if (this.tenant.invoice_others_attributes.filter( v => !v._destroy).length == 0){
      this.$emit('addButtonCallback')
    }
  },
  methods: {
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$emit('addButtonCallback')
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    removeButtonClickEvent (item) {
      this.$emit('removeButtonCallback', item)
    },
    /**
     * 請求情報（その他請求）
     * その他請求適用日変更　コールバック
     */
    othersInvoiceDateChangedCallback(value, other) {
      if (value) {
        other.others_invoice_date = moment(value).format('YYYY-MM')
      } else {
        other.others_invoice_date = null
      }
    },
  }
}
</script>